/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { TrackItTaskResultForEvaluation } from './TrackItTaskResultForEvaluation';
import {
    TrackItTaskResultForEvaluationFromJSON,
    TrackItTaskResultForEvaluationFromJSONTyped,
    TrackItTaskResultForEvaluationToJSON,
} from './TrackItTaskResultForEvaluation';

/**
 * 
 * @export
 * @interface ImportTrackItMeasurementForWorkStepDto
 */
export interface ImportTrackItMeasurementForWorkStepDto {
    /**
     * 
     * @type {string}
     * @memberof ImportTrackItMeasurementForWorkStepDto
     */
    resultId?: string | null;
    /**
     * 
     * @type {Array<TrackItTaskResultForEvaluation>}
     * @memberof ImportTrackItMeasurementForWorkStepDto
     */
    additionalResults: Array<TrackItTaskResultForEvaluation>;
    /**
     * 
     * @type {number}
     * @memberof ImportTrackItMeasurementForWorkStepDto
     */
    trackItMeasurementId: number;
    /**
     * 
     * @type {string}
     * @memberof ImportTrackItMeasurementForWorkStepDto
     */
    jobOccurrenceId: string;
    /**
     * 
     * @type {string}
     * @memberof ImportTrackItMeasurementForWorkStepDto
     */
    workStepId: string;
    /**
     * 
     * @type {string}
     * @memberof ImportTrackItMeasurementForWorkStepDto
     */
    $type?: ImportTrackItMeasurementForWorkStepDtoTypeEnum;
}


/**
 * @export
 */
export const ImportTrackItMeasurementForWorkStepDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoImportTrackItMeasurementForWorkStepDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementForWorkStepDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ImportTrackItMeasurementForWorkStepDtoTypeEnum = typeof ImportTrackItMeasurementForWorkStepDtoTypeEnum[keyof typeof ImportTrackItMeasurementForWorkStepDtoTypeEnum];



/**
 * Check if a given object implements the ImportTrackItMeasurementForWorkStepDto interface.
 */
export function instanceOfImportTrackItMeasurementForWorkStepDto(value?: unknown): value is ImportTrackItMeasurementForWorkStepDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ImportTrackItMeasurementForWorkStepDtoTypeEnum)[0];
}

export function ImportTrackItMeasurementForWorkStepDtoFromJSON(json: any): ImportTrackItMeasurementForWorkStepDto {
    return ImportTrackItMeasurementForWorkStepDtoFromJSONTyped(json, false);
}

export function ImportTrackItMeasurementForWorkStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportTrackItMeasurementForWorkStepDto {
    if (json == null) {
        return json;
    }
    return {
        
        'resultId': json['resultId'] == null ? undefined : json['resultId'],
        'additionalResults': ((json['additionalResults'] as Array<any>).map(TrackItTaskResultForEvaluationFromJSON)),
        'trackItMeasurementId': json['trackItMeasurementId'],
        'jobOccurrenceId': json['jobOccurrenceId'],
        'workStepId': json['workStepId'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ImportTrackItMeasurementForWorkStepDtoToJSON(value?: ImportTrackItMeasurementForWorkStepDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'resultId': value['resultId'],
        'additionalResults': ((value['additionalResults'] as Array<any>).map(TrackItTaskResultForEvaluationToJSON)),
        'trackItMeasurementId': value['trackItMeasurementId'],
        'jobOccurrenceId': value['jobOccurrenceId'],
        'workStepId': value['workStepId'],
        '$type': value['$type'],
    });
}

